import { render } from "./chat-products.vue?vue&type=template&id=662b4376"
import script from "./chat-products.vue?vue&type=script&lang=js"
export * from "./chat-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__